<template>
    <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        opacity="0.5"
        blur="1px"
        rounded="sm"
    >
        <apex-chart type="bar" :height="350" :options="chartOptions" :series="series" />
    </b-overlay>
</template>
<script>
import CONSTANTS from '../constants';
export default {
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        isRainData: {
            type: Boolean,
            default: true
        },
        isComparedData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            CONSTANTS
        };
    },
    computed: {
        series() {
            return [
                {
                    name: this.isRainData ? 'Lượng mưa' : 'Mực nước',
                    type: 'column',
                    data: this.listData.map((data) =>
                        !data.value
                            ? 0
                            : this.isRainData
                            ? parseFloat(data.value).toFixed(2)
                            : (parseFloat(data.value) / 100).toFixed(2)
                    )
                }
            ];
        },
        chartOptions() {
            let chartOptions = {
                chart: {
                    stacked: false,
                    toolbar: {
                        tools: {
                            download: false,
                            selection: false
                        }
                    }
                },
                grid: {
                    show: false,
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '80%',
                        distributed: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: []
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        formatter: (value) => {
                            return `${value} ${this.isRainData ? 'mm/h' : 'm'} `;
                        }
                    },
                    followCursor: true
                }
            };
            // Mapping xaxis data
            let categories = this.isComparedData
                ? this.listData.map((item) => item.name)
                : this.listData.map((item) => {
                      if (item.hour < 10) return `${item.date} 0${item.hour}:00`;
                      return `${item.date} ${item.hour}:00`;
                  });
            chartOptions.xaxis.categories = categories;

            return chartOptions;
        }
    },
    mounted() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
        }, 500);
    }
};
</script>